<template>
  <div class="bbp-accordion">
    <div class="bbp-accordion-button"
         @click.stop="openTextarea = !openTextarea"
    >
      <BBPIconArrow :class="{'bbp-accordion-button_open': openTextarea}"/>
      <span class="bbp-accordion-button__text">{{input.title}}</span>
    </div>
    <transition name="bbp-fade">
      <textarea class="bbp-input bbp-accordion__textarea"
                :class="{'bbp-accordion__textarea_closed': !openTextarea}"
                @keydown.enter.stop
                v-model="value"
                :disabled="input.disabled"
                v-autofocus="!!input.autofocus"
                :placeholder="input.placeholder"
                :style="{height: openTextarea ? input.height : 0}"
      />
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'
import BBPIconArrow from '@/components/Main/BBPIcons/BBPIconArrow'

export default {
  name: 'BBPAccordion',
  props: ['input', 'model', 'errorText'],
  components: {
    BBPIconArrow
  },
  data () {
    return {
      value: '',
      openTextarea: false
    }
  },
  methods: {
    setDefaultVal () {
      const value = get(this.model, this.input.model, '')
      if (value) {
        this.value = value
        this.openTextarea = true
      }
    }
  },
  watch: {
    value () {
      this.$emit('input', this.value)
    }
  },
  beforeMount () {
    this.setDefaultVal()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-accordion {
    display: flex;
    flex-direction: column;
    position: relative;

    &-button {
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: .6s linear;

      &_open {
        transform-origin: center center;
        transform: rotate(90deg);
      }

      &__icon {
        color: $color-denim;
        font-size: 10px;
      }

      &__text {
        color: $color-denim;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        padding-left: 8px;
      }
    }

    &__textarea {
      margin-top: 8px;
      resize: none;
      transition: .5s ease-in-out;

      &_closed {
        margin: 0;
        padding-bottom: 0;
        padding-top: 0;
        opacity: 0;
        border: 0 transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPAccordion/BBPAccordion.vue